import * as React from 'react'
import ReactSelect from 'react-select'
import styled, { AnyStyledComponent } from 'styled-components'
import * as constants from '../../../../static/constants'

interface IReactSelectWrap {
  title: any
  placeholder: any
  options: any[]
  onChange: any
  defaultValue: any
}

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    border: `1px solid ${constants.COLORS.divider}`,
    borderRadius: 4,
    '&:hover': { border: `1px solid ${constants.COLORS.primary}` },
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: constants.COLORS.primary,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
}

const ReactSelectWrap: React.VFC<IReactSelectWrap> = ({
  title,
  placeholder,
  options,
  onChange,
  defaultValue,
}) => (
  <S.ReactSelectWrapper>
    <p className="ReactSelect_Title">{title}</p>
    <div className="ReactSelect_Main">
      <ReactSelect
        placeholder={placeholder}
        options={options}
        isMulti={true}
        maxMenuHeight={192}
        onChange={onChange}
        styles={selectCustomStyles}
        defaultValue={defaultValue}
        menuPortalTarget={document.querySelector('body')}
      />
    </div>
  </S.ReactSelectWrapper>
)

const S: { [key: string]: AnyStyledComponent } = {}

S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 120px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
`
export default ReactSelectWrap
